import { render } from "./Steps1.vue?vue&type=template&id=dc190778"
import script from "./Steps1.vue?vue&type=script&lang=js"
export * from "./Steps1.vue?vue&type=script&lang=js"
script.render = render

export default script